export enum Stage {
	DEV = 'development',
	STAGING = 'staging',
	PROD = 'production',
}

export class EnvHelper {
	static identifyStageBasedOnUrl(): Stage {
		const url = window.location.href;

		//If the url contains '.dev.', then it is a dev stage
		if (url.includes('.dev.')) {
			return Stage.DEV;
		}

		//If the urle contains 'localhost', then it is a dev stage
		if (url.includes('localhost')) {
			return Stage.DEV;
		}

		//if the url contains '.staging.', then it is a staging stage
		if (url.includes('.staging.')) {
			return Stage.STAGING;
		}

		//otherwise it is a prod stage
		return Stage.PROD;
	}
}
